import React from 'react'
import CIcon from '@coreui/icons-react'

function Empty({ icon, text }) {
  return (
    <div className="empty">
      <CIcon icon={icon} />
      <p>{text}</p>
    </div>
  )
}

export default Empty
